exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-6c0e5f38]{text-decoration:none}", ""]);

// exports
